import React from 'react';
import buttonStyles from 'assets/css/Button.module.css';
import styles from 'assets/css/ExamInfo.module.css';
import { IconAngleRight } from '@ace/react-icons';
import CardLink from 'Components/Card/CardLink';
import downArrowImg from 'assets/images/down-arrow-celeste.png';

function ExamInformationCard () {
    return (
        <div className={styles.container}>
            <h4 className={styles.title}>
                Information about your Exam
            </h4>

            <p className={styles.description}>
                You have two options to complete your exam experience:
            </p>

            <ul className={styles.list}>
                <li>ACE Personal Training Certificate Exam (Non-proctored)</li>
                <li>ACE Certified Personal Trainer Exam (NCCA-accredited)</li>
            </ul>

            <CardLink
                linkText="Learn More"
                linkIcon={<IconAngleRight />}
                linkUrl="/fitness-certifications/exam-options/personal-trainer/"
                target="_blank"
                className={buttonStyles.floating}
            />

            <div className={styles.ctaWrap}>
                <img className={styles.ctaImg} src={downArrowImg} alt="Scroll Down" />

                <p className={styles.description}>
                    When you're ready, scroll down and locate your Exam Options tile. Toggle between the exam types!
                </p>
            </div>
        </div>
    )
}

export default ExamInformationCard;
